<!-- =========================================================================================
    File Name: FormWizard.vue
    Description: Form Wizard (third-party) - Imports page portions
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="extra-component-form-wizard-demo">

        <p class="mb-4">Está na hora de realizar a sua solicitação de crédito. Especifique o objetivo do crédito bem como as informações sobre a sua empresa.</p>
        
        <form-wizard-number-tab></form-wizard-number-tab>
    </div>
</template>

<script>
import FormWizardNumberTab from "./FormWizardNumberTab.vue"
export default {
    components: {
        FormWizardNumberTab
    }
}
</script>